<template>
  <ElUpload
    class="ui-upload"
    :file-list="fileList"
    :multiple="multiple"
    :disabled="disabled"
    :drag="false"
    :auto-upload="false"
    :on-preview="handlePreview"
    :on-change="handleChange"
    :on-remove="handleRemove"
    :before-remove="handleBeforeRemove">
    <ElButton type="primary" plain>
      <template #icon> <MiIcon icon="DOWNLOAD" /> </template>
      {{ text || $t('Base.Download') }}
    </ElButton>
  </ElUpload>
</template>

<script>
import axios from 'axios';
import noop from 'lodash.noop';

import { MiIcon } from '~shared/ui';
import { File as FileModel } from '@/models/File.model';
import { UploadFile } from '@/models/client/UploadFile.model';

export default {
  name: 'UiUpload',
  components: { MiIcon },
  emits: ['file:add', 'file:delete', 'file:preview'],
  props: {
    text: String,
    files: Array,
    multiple: Boolean,
    disabled: Boolean,
    drag: Boolean,
  },
  computed: {
    fileList() {
      return this.files.map((file) => ({
        ...file,
        name: file.filename ?? file.name ?? 'Untitled',
        status: UploadFile.enum.statuses.Success,
      }));
    },
  },

  methods: {
    async handleChange(file) {
      try {
        const { data } = await FileModel.create(file);
        this.$emit('file:add', data.data[0]);
      } catch (err) {
        this.$notify({
          type: 'error',
          title: axios.isAxiosError(err) ? err.message : String(err),
        });
      }
    },

    async handleBeforeRemove(file) {
      try {
        await FileModel.delete({ id: file.id });
        this.$emit('file:delete', file.id);
      } catch (err) {
        this.$notify({
          type: 'error',
          title: axios.isAxiosError(err) ? err.message : String(err),
        });
      }

      return false;
    },

    async handlePreview(file) {
      const a = document.createElement('a');
      a.setAttribute('target', '_blank');
      a.setAttribute('href', file.link);
      a.setAttribute('download', file.name || 'Untitled');

      document.body.appendChild(a);
      a.click();
      a.remove();
    },
    async handleRemove() {
      // not implemented
      noop();
    },
    async handleError() {
      // not implemented
      noop();
    },
    handleExceed() {
      // not implemented
      noop();
    },
  },
};
</script>

<style lang="scss" src="./index.scss" />
<i18n src="@/locales/base.locales.json" />
<i18n src="@/locales/notifications.locales.json" />
